module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('p', {
    staticClass: "sp"
  }), _vm._v(" "), _c('p', {
    staticClass: "FM-Epigraph-verse-fmepiv-first"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_7",
      "title": "7"
    }
  }, [_vm._v("THE LAKEMAN’S LAMENT")])])]), _vm._v(" "), _c('p', {
    staticClass: "FM-Epigraph-verse-fmepiv"
  }, [_vm._v("On the fireach deamhain sit")]), _vm._v(" "), _c('p', {
    staticClass: "FM-Epigraph-verse-fmepiv"
  }, [_vm._v("Curses muttered, fire spits;")]), _vm._v(" "), _c('p', {
    staticClass: "FM-Epigraph-verse-fmepiv"
  }, [_vm._v("Hunting people, their delight")]), _vm._v(" "), _c('p', {
    staticClass: "FM-Epigraph-verse-fmepiv"
  }, [_vm._v("Spilling blood and making fright.")]), _vm._v(" "), _c('p', {
    staticClass: "FM-Epigraph-verse-fmepiv"
  }, [_vm._v("Better fear than praise of men")]), _vm._v(" "), _c('p', {
    staticClass: "FM-Epigraph-verse-fmepiv"
  }, [_vm._v("The deamhain strike with spear not pen;")]), _vm._v(" "), _c('p', {
    staticClass: "FM-Epigraph-verse-fmepiv"
  }, [_vm._v("For the bounty they will take")]), _vm._v(" "), _c('p', {
    staticClass: "FM-Epigraph-verse-fmepiv"
  }, [_vm._v("Food and furs and bones to break.")]), _vm._v(" "), _c('p', {
    staticClass: "FM-Epigraph-verse-fmepiv"
  }, [_vm._v("Deamhan footfalls leave no mark")]), _vm._v(" "), _c('p', {
    staticClass: "FM-Epigraph-verse-fmepiv"
  }, [_vm._v("Coming silent, can’no hark;")]), _vm._v(" "), _c('p', {
    staticClass: "FM-Epigraph-verse-fmepiv"
  }, [_vm._v("Come in fury and in shade")]), _vm._v(" "), _c('p', {
    staticClass: "FM-Epigraph-verse-fmepiv"
  }, [_vm._v("Come with magic in the blade.")]), _vm._v(" "), _c('p', {
    staticClass: "FM-Epigraph-verse-fmepiv"
  }, [_vm._v("Glit’ring spear alit with fire")]), _vm._v(" "), _c('p', {
    staticClass: "FM-Epigraph-verse-fmepiv"
  }, [_vm._v("Lightning speaks with deamhan ire;")]), _vm._v(" "), _c('p', {
    staticClass: "FM-Epigraph-verse-fmepiv"
  }, [_vm._v("Throwing stones without a sling")]), _vm._v(" "), _c('p', {
    staticClass: "FM-Epigraph-verse-fmepiv"
  }, [_vm._v("Fly away without a wing!")]), _vm._v(" "), _c('p', {
    staticClass: "FM-Epigraph-verse-fmepiv"
  }, [_vm._v("Oftentimes a lakeman strays")]), _vm._v(" "), _c('p', {
    staticClass: "FM-Epigraph-verse-fmepiv"
  }, [_vm._v("Into fireach deamhan’s way;")]), _vm._v(" "), _c('p', {
    staticClass: "FM-Epigraph-verse-fmepiv"
  }, [_vm._v("Oftentimes the deamhan’s smile")]), _vm._v(" "), _c('p', {
    staticClass: "FM-Epigraph-verse-fmepiv"
  }, [_vm._v("Bleeds the kill for all the while.")]), _vm._v(" "), _c('p', {
    staticClass: "FM-Epigraph-verse-fmepiv"
  }, [_vm._v("Usgar deamhan, why such joy")]), _vm._v(" "), _c('p', {
    staticClass: "FM-Epigraph-verse-fmepiv"
  }, [_vm._v("To break the smile of a boy;")]), _vm._v(" "), _c('p', {
    staticClass: "FM-Epigraph-verse-fmepiv"
  }, [_vm._v("Usgar deamhan, why delight")]), _vm._v(" "), _c('p', {
    staticClass: "FM-Epigraph-verse-fmepiv"
  }, [_vm._v("In spilling blood and making fright?")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0825b0b2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/epigraph.vue
// module id = 72
// module chunks = 0